export default __webpack_public_path__ + "static/media/reveal.b0e90e3a.png";